// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cd-a";
export var fulfillmentFormRail = "_cd-9";
export var headerTitleRow = "_cd-c";
export var orderDetailsWrapper = "_cd-7";
export var orderLinkTrigger = "_cd-2";
export var paymentInformationGrid = "_cd-h";
export var paymentSummaryColumn = "_cd-i";
export var shipmentContainer = "_cd-b";
export var shipmentDetailsMainPane = "_cd-8";
export var shipmentNavigationCard = "_cd-5";
export var shipmentNavigationRail = "_cd-3";
export var shipmentNavigationRailHeader = "_cd-4";
export var shipmentSummaryFact = "_cd-e";
export var shipmentSummaryGrid = "_cd-d";
export var shipmentSummaryMetadataRow = "_cd-f";
export var shipmentSummaryTags = "_cd-g";
export var shipmentWorkspace = "_cd-0";
export var shipmentWorkspaceContent = "_cd-6";
export var shipmentWorkspaceHeader = "_cd-1";